import Actions from 'redux/actions'

type State = { open: boolean }

const initialState = {
  open: false,
}

export default (
  state: State = initialState,
  action: { type: Actions.CLOSE_LANGUAGE_MODAL | Actions.OPEN_LANGUAGE_MODAL },
): State => {
  switch (action.type) {
    case Actions.OPEN_LANGUAGE_MODAL: {
      return {
        ...state,
        open: true,
      }
    }
    case Actions.CLOSE_LANGUAGE_MODAL: {
      return {
        ...state,
        open: false,
      }
    }
    default:
      return state
  }
}
